var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "row mb-5" },
    [
      _c("b-col", { attrs: { md: "12" } }, [
        _c("header", { staticClass: "mt-5 bx-header-title" }, [
          _c("h2", {
            staticClass: "inline",
            attrs: { id: "nueva-solicitud-id" },
            domProps: {
              textContent: _vm._s(
                !_vm.edicionAreaConocmiento && !_vm.reseteoSede
                  ? _vm.$t("nueva-solicitud.title")
                  : _vm.$t("nueva-solicitud.editTitle")
              ),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { sm: "12", lg: "12" } },
        [
          _c("b-alert", {
            attrs: { show: "", variant: "info" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("nueva-solicitud.alert.informativo")),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { md: "12" } },
        [_c("alerta", { ref: "alerta" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          attrs: { md: "12" },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function () {
                return [_c("skeleton", { attrs: { type: "form" } })]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "b-row",
            [
              !_vm.edicionAreaConocmiento
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-radio", {
                        staticClass: "mb-4",
                        attrs: {
                          id: "nueva-solicitud-tipo-solicitante-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.tipo-solicitante.label"
                          ),
                          options: _vm.tipoSolicitanteOptions,
                          readonly: false,
                          required: false,
                          valid: _vm.$v.nuevaSolicitud.tipoSolicitante.$dirty
                            ? !_vm.$v.nuevaSolicitud.tipoSolicitante.$error
                            : null,
                          staked: true,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.tipoSolicitante.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.tipo-solicitante.validations.required"
                            ),
                          },
                        },
                        on: {
                          change: function ($event) {
                            return _vm.cambiaRadio($event.id)
                          },
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.tipoSolicitante.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.tipoSolicitante,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.nuevaSolicitud.tipoSolicitante.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.reseteoSede
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("input-text", {
                                attrs: {
                                  id: "nueva-solicitud-noRegistro-id",
                                  label: _vm.$t(
                                    "nueva-solicitud.form.noRegistro.label"
                                  ),
                                  required: false,
                                  readonly: _vm.readonlyRfc || _vm.reseteoSede,
                                },
                                model: {
                                  value: _vm.noRegistro,
                                  callback: function ($$v) {
                                    _vm.noRegistro = $$v
                                  },
                                  expression: "noRegistro",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && !_vm.edicionAreaConocmiento
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "nueva-solicitud-sector-id",
                          label: _vm.$t("nueva-solicitud.form.sector.label"),
                          description: _vm.$t(
                            "nueva-solicitud.form.sector.description"
                          ),
                          options: _vm.sectorOptions,
                          required: true,
                          valid: _vm.$v.nuevaSolicitud.sector.$dirty
                            ? !_vm.$v.nuevaSolicitud.sector.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.sector.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.sector.validations.required"
                            ),
                          },
                        },
                        on: {
                          change: function ($event) {
                            return _vm.cambiaSector($event.id)
                          },
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.sector.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.sector,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.nuevaSolicitud.sector.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.edicionAreaConocmiento
                ? _c(
                    "b-col",
                    { attrs: { md: _vm.esMoral ? "6" : "12" } },
                    [
                      _c("input-text", {
                        attrs: {
                          id: "nueva-solicitud-rfc-id",
                          label: _vm.$t("nueva-solicitud.form.rfc.label"),
                          description: !_vm.reseteoSede
                            ? _vm.$t("nueva-solicitud.form.rfc.description")
                            : "",
                          placeholder: _vm.$t(
                            "nueva-solicitud.form.rfc.placeHolder"
                          ),
                          required: true,
                          readonly: _vm.readonlyRfc || _vm.reseteoSede,
                          tooltip: _vm.$t("nueva-solicitud.form.rfc.tooltip"),
                          valid: _vm.$v.nuevaSolicitud.rfc.$dirty
                            ? !_vm.$v.nuevaSolicitud.rfc.$error
                            : null,
                          validationsCommons: {
                            requiredValue: !_vm.$v.nuevaSolicitud.rfc.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.rfc.validations.required"
                            ),
                            minValue: !_vm.$v.nuevaSolicitud.rfc.minLength,
                            minMessage: _vm.$t(
                              "nueva-solicitud.form.rfc.validations.minMessage",
                              { min: "13" }
                            ),
                            maxValue: !_vm.$v.nuevaSolicitud.rfc.maxLength,
                            maxMessage: _vm.$t(
                              "nueva-solicitud.form.rfc.validations.maxMessage",
                              { max: "14" }
                            ),
                            regexValue: !_vm.$v.nuevaSolicitud.rfc.RFC,
                            regexMessage: _vm.$t(
                              "nueva-solicitud.form.rfc.validations.regexMessage"
                            ),
                          },
                        },
                        on: { change: _vm.existeRFC },
                        model: {
                          value: _vm.$v.nuevaSolicitud.rfc.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.nuevaSolicitud.rfc, "$model", $$v)
                          },
                          expression: "$v.nuevaSolicitud.rfc.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && !_vm.edicionAreaConocmiento
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-text", {
                        attrs: {
                          id: "nueva-solicitud-razon-social-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.razon-social.label"
                          ),
                          description: !_vm.reseteoSede
                            ? _vm.$t(
                                "nueva-solicitud.form.razon-social.description"
                              )
                            : "",
                          placeholder: _vm.$t(
                            "nueva-solicitud.form.razon-social.placeHolder"
                          ),
                          required: true,
                          readonly: _vm.reseteoSede,
                          valid: _vm.$v.nuevaSolicitud.razonSocial.$dirty
                            ? !_vm.$v.nuevaSolicitud.razonSocial.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.razonSocial.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.razon-social.validations.required"
                            ),
                            minValue:
                              !_vm.$v.nuevaSolicitud.razonSocial.minLength,
                            minMessage: _vm.$t(
                              "nueva-solicitud.form.razon-social.validations.minMessage",
                              { min: "1" }
                            ),
                            maxValue:
                              !_vm.$v.nuevaSolicitud.razonSocial.maxLength,
                            maxMessage: _vm.$t(
                              "nueva-solicitud.form.razon-social.validations.maxMessage",
                              { max: "50" }
                            ),
                            regexValue: !_vm.$v.nuevaSolicitud.razonSocial.RFC,
                            regexMessage: _vm.$t(
                              "nueva-solicitud.form.razon-social.validations.regexMessage"
                            ),
                          },
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.razonSocial.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.razonSocial,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.nuevaSolicitud.razonSocial.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.esMoral && _vm.sectorPrivada) || !_vm.esMoral
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "nueva-solicitud-tipo-institucion-empresa-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.tipo-institucion-empresa.label"
                          ),
                          description: _vm.$t(
                            "nueva-solicitud.form.tipo-institucion-empresa.description"
                          ),
                          options: _vm.tipoInstitucionEmpresaOptions,
                          required: true,
                          readonly: !_vm.esMoral,
                          valid: _vm.$v.nuevaSolicitud.tipoInstitucionEmpresa
                            .$dirty
                            ? !_vm.$v.nuevaSolicitud.tipoInstitucionEmpresa
                                .$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.tipoInstitucionEmpresa
                                .required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.tipo-institucion-empresa.validations.required"
                            ),
                          },
                        },
                        on: {
                          change: function ($event) {
                            return _vm.cambiaTipoInstitucionEmpresa($event.id)
                          },
                        },
                        model: {
                          value:
                            _vm.$v.nuevaSolicitud.tipoInstitucionEmpresa.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.tipoInstitucionEmpresa,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.nuevaSolicitud.tipoInstitucionEmpresa.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.esMoral && _vm.tipoInsEmpresaEmpresa) ||
              (_vm.esMoral && _vm.sectorPublica && !_vm.edicionAreaConocmiento)
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      !_vm.sectorPublica && !_vm.juridicaReadonly
                        ? _c("input-select-one", {
                            attrs: {
                              id: "nueva-solicitud-figura-juridica-id",
                              label: _vm.$t(
                                "nueva-solicitud.form.figura-juridica.label"
                              ),
                              description: _vm.$t(
                                "nueva-solicitud.form.figura-juridica.description"
                              ),
                              options: _vm.figuraJuridicaOptions,
                              required: true,
                              readonly: _vm.juridicaReadonly,
                              valid: _vm.$v.nuevaSolicitud.figuraJuridica.$dirty
                                ? !_vm.$v.nuevaSolicitud.figuraJuridica.$error
                                : null,
                              validationsCommons: {
                                requiredValue:
                                  !_vm.$v.nuevaSolicitud.figuraJuridica
                                    .required,
                                requiredMessage: _vm.$t(
                                  "nueva-solicitud.form.figura-juridica.validations.required"
                                ),
                              },
                            },
                            model: {
                              value:
                                _vm.$v.nuevaSolicitud.figuraJuridica.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.nuevaSolicitud.figuraJuridica,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.nuevaSolicitud.figuraJuridica.$model",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && _vm.tipoInsEmpresaEmpresa
                ? _c(
                    "div",
                    [
                      !_vm.edicionAreaConocmiento
                        ? _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c("scian", {
                                attrs: {
                                  id: "nueva-solicitud-desarrollos-tecnologicos-innovaciones-scian-id",
                                  readonly: false,
                                  edit: _vm.nuevaSolicitud.scian.sector,
                                  validComponent: _vm.validChildScian,
                                },
                                model: {
                                  value: _vm.$v.nuevaSolicitud.scian.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.nuevaSolicitud.scian,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.nuevaSolicitud.scian.$model",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.edicionAreaConocmiento
                        ? _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c("ocde", {
                                attrs: {
                                  id: "nueva-solicitud-desarrollos-tecnologicos-innovaciones-ocde-id",
                                  readonly: false,
                                  edit: _vm.nuevaSolicitud.ocde.sector,
                                  validComponent: _vm.validChildOcde,
                                },
                                model: {
                                  value: _vm.$v.nuevaSolicitud.ocde.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.nuevaSolicitud.ocde,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.nuevaSolicitud.ocde.$model",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("area-conocimiento", {
                            attrs: {
                              id: "area-conocimiento-id",
                              readonly: false,
                              required: true,
                              validA: _vm.validChildArea,
                              edit: _vm.$v.nuevaSolicitud.areaConocimiento
                                .$model,
                            },
                            model: {
                              value:
                                _vm.$v.nuevaSolicitud.areaConocimiento.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.nuevaSolicitud.areaConocimiento,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.nuevaSolicitud.areaConocimiento.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.edicionAreaConocmiento
                        ? _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c("input-select-one", {
                                attrs: {
                                  id: "nueva-solicitud-tamanio-empresa-id",
                                  label: _vm.$t(
                                    "nueva-solicitud.form.tamanio-empresa.label"
                                  ),
                                  description: _vm.$t(
                                    "nueva-solicitud.form.tamanio-empresa.description"
                                  ),
                                  options: _vm.tamanioEmpresaOptions,
                                  required: true,
                                  valid: _vm.$v.nuevaSolicitud.tamanioEmpresa
                                    .$dirty
                                    ? !_vm.$v.nuevaSolicitud.tamanioEmpresa
                                        .$error
                                    : null,
                                  validationsCommons: {
                                    requiredValue:
                                      !_vm.$v.nuevaSolicitud.tamanioEmpresa
                                        .required,
                                    requiredMessage: _vm.$t(
                                      "nueva-solicitud.form.tamanio-empresa.validations.required"
                                    ),
                                  },
                                },
                                model: {
                                  value:
                                    _vm.$v.nuevaSolicitud.tamanioEmpresa.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.nuevaSolicitud.tamanioEmpresa,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.nuevaSolicitud.tamanioEmpresa.$model",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && _vm.sectorPublica
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "nueva-solicitud-nivel-id",
                          label: _vm.$t("nueva-solicitud.form.nivel.label"),
                          description: _vm.$t(
                            "nueva-solicitud.form.nivel.description"
                          ),
                          options: _vm.nivelOptions,
                          required: true,
                          valid: _vm.$v.nuevaSolicitud.nivel.$dirty
                            ? !_vm.$v.nuevaSolicitud.nivel.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.nivel.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.nivel.validations.required"
                            ),
                          },
                        },
                        on: {
                          change: function ($event) {
                            return _vm.cambiaNivel($event.id)
                          },
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.nivel.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.nuevaSolicitud.nivel, "$model", $$v)
                          },
                          expression: "$v.nuevaSolicitud.nivel.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && _vm.sectorPublica && _vm.tipoInstitucionEntidadB
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "nueva-solicitud-tipo-institucion-entidad-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.tipo-institucion-entidad.label"
                          ),
                          description: _vm.$t(
                            "nueva-solicitud.form.tipo-institucion-entidad.description"
                          ),
                          options: _vm.tipoInstitucionEntidadOptions,
                          required: true,
                          valid: _vm.$v.nuevaSolicitud.tipoInstitucionEntidad
                            .$dirty
                            ? !_vm.$v.nuevaSolicitud.tipoInstitucionEntidad
                                .$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.tipoInstitucionEntidad
                                .required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.tipo-institucion-entidad.validations.required"
                            ),
                          },
                        },
                        on: {
                          change: function ($event) {
                            return _vm.cambiaTipoInstEntidad($event.id)
                          },
                        },
                        model: {
                          value:
                            _vm.$v.nuevaSolicitud.tipoInstitucionEntidad.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.tipoInstitucionEntidad,
                              "$model",
                              $$v
                            )
                          },
                          expression:
                            "$v.nuevaSolicitud.tipoInstitucionEntidad.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && (_vm.tipoInsEmpresaEducacion || _vm.clasificacionB)
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "nueva-solicitud-clasificacion-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.clasificacion.label"
                          ),
                          description: _vm.$t(
                            "nueva-solicitud.form.clasificacion.description"
                          ),
                          options: _vm.clasificacionOptions,
                          required: true,
                          valid: _vm.$v.nuevaSolicitud.clasificacion.$dirty
                            ? !_vm.$v.nuevaSolicitud.clasificacion.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.clasificacion.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.clasificacion.validations.required"
                            ),
                          },
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.clasificacion.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.clasificacion,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.nuevaSolicitud.clasificacion.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && _vm.sectorSocial
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-select-one", {
                        attrs: {
                          id: "nueva-solicitud-grupo-social-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.grupo-social.label"
                          ),
                          description: _vm.$t(
                            "nueva-solicitud.form.grupo-social.description"
                          ),
                          options: _vm.grupoSocialOptions,
                          required: true,
                          valid: _vm.$v.nuevaSolicitud.grupoSocial.$dirty
                            ? !_vm.$v.nuevaSolicitud.grupoSocial.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.grupoSocial.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.grupo-social.validations.required"
                            ),
                          },
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.grupoSocial.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.grupoSocial,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.nuevaSolicitud.grupoSocial.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esMoral && _vm.sectorSocial
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("input-text-area", {
                        attrs: {
                          id: "nueva-solicitud-especificar-id",
                          label: _vm.$t(
                            "nueva-solicitud.form.especificar.label"
                          ),
                          description: _vm.$t(
                            "nueva-solicitud.form.especificar.description"
                          ),
                          readonly: false,
                          required: true,
                          placeholder: _vm.$t(
                            "nueva-solicitud.form.especificar.placeHolder"
                          ),
                          valid: _vm.$v.nuevaSolicitud.especificar.$dirty
                            ? !_vm.$v.nuevaSolicitud.especificar.$error
                            : null,
                          validationsCommons: {
                            requiredValue:
                              !_vm.$v.nuevaSolicitud.especificar.required,
                            requiredMessage: _vm.$t(
                              "nueva-solicitud.form.especificar.validations.required"
                            ),
                            minValue:
                              !_vm.$v.nuevaSolicitud.especificar.minLength,
                            minMessage: _vm.$t(
                              "nueva-solicitud.especificar.form.validations.minMessage",
                              { min: "1" }
                            ),
                            maxValue:
                              !_vm.$v.nuevaSolicitud.especificar.maxLength,
                            maxMessage: _vm.$t(
                              "nueva-solicitud.especificar.form.validations.maxMessage",
                              { max: "2000" }
                            ),
                          },
                          maxCaracteres: 2000,
                        },
                        model: {
                          value: _vm.$v.nuevaSolicitud.especificar.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.nuevaSolicitud.especificar,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.nuevaSolicitud.especificar.$model",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.esMoral
                ? [
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("input-text", {
                          attrs: {
                            id: "ueva-solicitud-nombre-id",
                            label: _vm.$t("nueva-solicitud.form.nombre.label"),
                            description: _vm.$t(
                              "nueva-solicitud.form.nombre.description"
                            ),
                            readonly: true,
                            required: false,
                            valid: _vm.$v.nuevaSolicitud.nombre.$dirty
                              ? !_vm.$v.nuevaSolicitud.nombre.$error
                              : null,
                            validationsCommons: {
                              requiredValue:
                                !_vm.$v.nuevaSolicitud.nombre.required,
                              requiredMessage: _vm.$t(
                                "nueva-solicitud.form.nombre.validations.required"
                              ),
                              minValue: !_vm.$v.nuevaSolicitud.nombre.minLength,
                              minMessage: _vm.$t(
                                "nueva-solicitud.form.nombre.validations.minMessage",
                                { min: "1" }
                              ),
                              maxValue: !_vm.$v.nuevaSolicitud.nombre.maxLength,
                              maxMessage: _vm.$t(
                                "nueva-solicitud.form.nombre.validations.maxMessage",
                                { max: "256" }
                              ),
                            },
                          },
                          model: {
                            value: _vm.$v.nuevaSolicitud.nombre.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.nuevaSolicitud.nombre,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.nuevaSolicitud.nombre.$model",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("input-text", {
                          attrs: {
                            id: "nueva-solicitud-primer-apellido-id",
                            label: _vm.$t(
                              "nueva-solicitud.form.primer-apellido.label"
                            ),
                            description: _vm.$t(
                              "nueva-solicitud.form.primer-apellido.description"
                            ),
                            readonly: true,
                            required: false,
                            valid: _vm.$v.nuevaSolicitud.primerApellido.$dirty
                              ? !_vm.$v.nuevaSolicitud.primerApellido.$error
                              : null,
                            validationsCommons: {
                              requiredValue:
                                !_vm.$v.nuevaSolicitud.primerApellido.required,
                              requiredMessage: _vm.$t(
                                "nueva-solicitud.form.primer-apellido.validations.required"
                              ),
                              minValue:
                                !_vm.$v.nuevaSolicitud.primerApellido.minLength,
                              minMessage: _vm.$t(
                                "nueva-solicitud.form.primer-apellido.validations.minMessage",
                                { min: "1" }
                              ),
                              maxValue:
                                !_vm.$v.nuevaSolicitud.primerApellido.maxLength,
                              maxMessage: _vm.$t(
                                "nueva-solicitud.form.primer-apellido.validations.maxMessage",
                                { max: "256" }
                              ),
                            },
                          },
                          model: {
                            value: _vm.$v.nuevaSolicitud.primerApellido.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.nuevaSolicitud.primerApellido,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.nuevaSolicitud.primerApellido.$model",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("input-text", {
                          attrs: {
                            id: "nueva-solicitud-segundo-apellido-id",
                            label: _vm.$t(
                              "nueva-solicitud.form.segundo-apellido.label"
                            ),
                            description: _vm.$t(
                              "nueva-solicitud.form.segundo-apellido.description"
                            ),
                            readonly: true,
                            required: false,
                            valid: _vm.$v.nuevaSolicitud.segundoApellido.$dirty
                              ? !_vm.$v.nuevaSolicitud.segundoApellido.$error
                              : null,
                            validationsCommons: {
                              requiredValue:
                                !_vm.$v.nuevaSolicitud.segundoApellido.required,
                              requiredMessage: _vm.$t(
                                "nueva-solicitud.form.segundo-apellido.validations.required"
                              ),
                              minValue:
                                !_vm.$v.nuevaSolicitud.segundoApellido
                                  .minLength,
                              minMessage: _vm.$t(
                                "nueva-solicitud.form.segundo-apellido.validations.minMessage",
                                { min: "1" }
                              ),
                              maxValue:
                                !_vm.$v.nuevaSolicitud.segundoApellido
                                  .maxLength,
                              maxMessage: _vm.$t(
                                "nueva-solicitud.form.segundo-apellido.validations.maxMessage",
                                { max: "256" }
                              ),
                            },
                          },
                          model: {
                            value: _vm.$v.nuevaSolicitud.segundoApellido.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.nuevaSolicitud.segundoApellido,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.nuevaSolicitud.segundoApellido.$model",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { md: "12" } }, [
                      _c("div", { staticClass: "border-custom" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("span", {
                            staticClass: "font-weight-bold",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "nueva-solicitud.form.actividad-preponderante.preLabel"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("input-select-radio", {
                            staticClass: "mb-4 mt-2",
                            attrs: {
                              id: "nueva-solicitud-actividad-preponderante-id",
                              label: _vm.$t(
                                "nueva-solicitud.form.actividad-preponderante.label"
                              ),
                              options: _vm.actividadPreponderanteOptions,
                              readonly: false,
                              required: false,
                              valid: _vm.$v.nuevaSolicitud
                                .actividadPreponderante.$dirty
                                ? !_vm.$v.nuevaSolicitud.actividadPreponderante
                                    .$error
                                : null,
                              staked: true,
                              validationsCommons: {
                                requiredValue:
                                  !_vm.$v.nuevaSolicitud.actividadPreponderante
                                    .required,
                                requiredMessage: _vm.$t(
                                  "nueva-solicitud.form.actividad-preponderante.validations.required"
                                ),
                              },
                            },
                            model: {
                              value:
                                _vm.$v.nuevaSolicitud.actividadPreponderante
                                  .$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.nuevaSolicitud.actividadPreponderante,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.nuevaSolicitud.actividadPreponderante.$model",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "12" } }, [
                _c("div", { staticClass: "border-custom" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-7 float-right mt-4" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-primary", size: "lg" },
                        on: {
                          click: function ($event) {
                            return _vm.cancel()
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("Cancelar")]),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "ban" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.edicionAreaConocmiento && !_vm.reseteoSede
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "primary", size: "lg" },
                            on: {
                              click: function ($event) {
                                return _vm.save(_vm.$v.nuevaSolicitud.$model)
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("entity.action.save")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "mr-2",
                              attrs: { icon: "save" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.edicionAreaConocmiento
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "primary", size: "lg" },
                            on: {
                              click: function ($event) {
                                return _vm.updateRegistroSector(
                                  _vm.$v.nuevaSolicitud.areaConocimiento.$model
                                )
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("entity.action.update")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "mr-2",
                              attrs: { icon: "save" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.reseteoSede
                      ? _c(
                          "b-button",
                          {
                            attrs: { variant: "primary", size: "lg" },
                            on: {
                              click: function ($event) {
                                return _vm.updateRegistro(
                                  _vm.$v.nuevaSolicitud.$model
                                )
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("entity.action.update")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "mr-2",
                              attrs: { icon: "save" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }